module.exports = __webpack_public_path__ + "img/09.70d5f103.png";